var map = {
	"./header-desktop.svg": "l2PT",
	"./header-mobile.svg": "2Zj9",
	"./national-flag-arg.svg": "SX9H",
	"./national-flag-aus.svg": "91dQ",
	"./national-flag-blank.svg": "2OAI",
	"./national-flag-can.svg": "9Lce",
	"./national-flag-eng.svg": "2oAC",
	"./national-flag-eng_.svg": "RDJc",
	"./national-flag-fij.svg": "9278",
	"./national-flag-fra.svg": "LR7+",
	"./national-flag-geo.svg": "VfL6",
	"./national-flag-ire.svg": "tAps",
	"./national-flag-ita.svg": "oXoT",
	"./national-flag-jpn.svg": "xnvm",
	"./national-flag-nam.svg": "HlOD",
	"./national-flag-nz.svg": "KOwi",
	"./national-flag-rsa.svg": "h2Th",
	"./national-flag-rus.svg": "sh3f",
	"./national-flag-sam.svg": "HST/",
	"./national-flag-sco.svg": "EOdR",
	"./national-flag-ton.svg": "StI+",
	"./national-flag-uru.svg": "zAHe",
	"./national-flag-usa.svg": "AHhb",
	"./national-flag-wal.svg": "NjEZ",
	"./player-ball.svg": "Ot59"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 0